import React from 'react';
import PropTypes from 'prop-types';

const OppScoreLevelsTooltip = ({ title, highLabel, mediumLabel, lowLabel, highDescription, mediumDescription, lowDescription }) => {
	return (
		<div className='opp-score-levels-tooltip'>
			<div className='opp-score-levels-title'>{title}</div>
			
			<div className='opp-score-levels-items'>
				<div className='opp-score-level-item high'>
					<span className='opp-score-level-label'>{highLabel}: </span>
					<span className='opp-score-level-description'>{highDescription}</span>
				</div>
				
				<div className='opp-score-level-item medium'>
					<span className='opp-score-level-label'>{mediumLabel}: </span>
					<span className='opp-score-level-description'>{mediumDescription}</span>
				</div>
				
				<div className='opp-score-level-item low'>
					<span className='opp-score-level-label'>{lowLabel}: </span>
					<span className='opp-score-level-description'>{lowDescription}</span>
				</div>
			</div>
		</div>
	);
};

OppScoreLevelsTooltip.propTypes = {
	title: PropTypes.string.isRequired,
	highLabel: PropTypes.string.isRequired,
	mediumLabel: PropTypes.string.isRequired,
	lowLabel: PropTypes.string.isRequired,
	highDescription: PropTypes.string.isRequired,
	mediumDescription: PropTypes.string.isRequired,
	lowDescription: PropTypes.string.isRequired,
};

export default OppScoreLevelsTooltip;
